import React from 'react';
import { Helmet } from 'react-helmet-async';

const JsonLd = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

// Example organization structured data
export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Diaa Corp",
  "url": "https://diaacorp.com",
  "logo": "https://diaacorp.com/logo.png",
  "sameAs": [
    "https://www.linkedin.com/company/diaacorp",
    "https://twitter.com/diaacorp"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "",
    "contactType": "customer service",
    "email": "info@diaacorp.com",
    "availableLanguage": ["English"]
  }
};

// Example service structured data
export const serviceJsonLd = (name, description, url) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": name,
  "description": description,
  "provider": {
    "@type": "Organization",
    "name": "Diaa Corp",
    "url": "https://diaacorp.com"
  },
  "serviceType": "IT Service",
  "url": url
});

// Example breadcrumb structured data
export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `https://diaacorp.com${item.url}`
  }))
});

export default JsonLd; 